//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import axios from 'axios';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getEncrypted } from '~/pages/onlineService/utils';
import { chatMessages } from '~/net/fetch';
import config from '~/config';

export const baseURl =
  typeof window === 'undefined' ? config.PortalBaseURL : config.PortalBrowserBaseURL;
// 引入marked
const marked = require('marked');
marked.setOptions({
  // 禁用严格模式（允许不规范的标题语法）
  pedantic: false,
  gfm: true, // 启用GitHub风格的Markdown
  tables: true, // 启用表格解析
  breaks: true, // 启用换行符

  sanitize: false, // 不 sanitize 输出
  smartLists: true, // 智能列表解析
  smartypants: true, // 智能标点符号
  headerIds: true, // 生成标题ID
  headerPrefix: 'header-', // 标题ID前缀
  // 自定义渲染器，处理特殊样式
  renderer: new marked.Renderer({
    // 自定义标题渲染，添加样式类
    heading(text, level, raw) {
      return `<h${level} class="markdown-heading">${text}</h${level}>`;
    },
    // 自定义列表渲染
    list(body, ordered, start) {
      const type = ordered ? 'ol' : 'ul';
      return `<${type} class="markdown-list">${body}</${type}>`;
    },
  }),
});
export default {
  name: 'ChatBox',
  props: {
    type: {
      type: [Number, null],
      default: null,
    },
    name: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      question: '',
      sendDisabled: false,
      conversationId: '',
      messageId: '',
      questionsAndAnswers: [],
      interval: null,
      timer: null,
      keyword: new Date().getTime(),
      cancel: null,

      apiEndpoint: `${baseURl}/ai/chatMessages`,
      apiKey: 'app-QAXb9f7NxtNOcKWlfsgxUGju',
      isStreaming: false,
      showBotResponse: false,
      messageTime: '',
      responseTime: '',
      totalChars: 0,
      errorMessage: '',
      controller: null,
      partialData: '', // 用于存储截断的SSE消息
      startTime: 0,
      endTime: 0,
      thinkingTime: '',
      jsonDataOther: [],
    };
  },
  beforeDestroy() {
    this.$bus.$off('clearAnswers', this.clearAnswers);
    this.clearAnswers();
  },
  computed: {
    ...mapState(['user']),
    showReferenceInfor() {
      return [0, 1, 2, 3].includes(this.type);
    },
    allFunctions() {
      const funs = [
        {
          title: this.type === null ? '一、为您匹配成果信息：' : '为您匹配成果信息：',
          key: 'goodsList',
        },
        {
          title: this.type === null ? '二、为您匹配需求信息：' : '为您匹配需求信息：',
          key: 'demandList',
        },
        {
          title: this.type === null ? '三、为您匹配服务机构信息：' : '为您匹配服务机构信息：',
          key: 'orgList',
        },
        {
          title: this.type === null ? '四、为您匹配技术经理人信息：' : '为您匹配技术经理人信息：',
          key: 'jlrList',
        },
      ];
      return this.type === null ? funs : [funs[this.type]];
    },
    appId() {
      const map = ['jstec-jsjlr-zcg', 'jstec-jsjlr-zxq', 'jstec-jsjlr-zfwjg', 'jstec-jsjlr-zjsjlr'];
      return this.type === null ? 'jstec-jsjlr' : map[this.type];
    },
  },
  mounted() {
    // 清空会话
    this.$bus.$on('clearAnswers', this.clearAnswers);
  },
  methods: {
    showEmpty(structuredData, key) {
      return !structuredData[key] || (structuredData[key] && structuredData[key].length <= 0);
    },
    clearAnswers() {
      this.questionsAndAnswers = [];
      this.sendDisabled = false;
      // 重置对话
      this.conversationId = '';
      // 重置计时器
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      // 取消请求
      if (this.cancel) {
        this.cancel('取消聊天请求');
        this.cancel = null;
      }
    },
    goDetail(item, active) {
      if (active === 'goodsList') {
        // 打开新标签页
        item.id && window.open(`/goods?id=${item.id}`);
      } else if (active === 'demandList') {
        item.id && window.open(`/crowdsourcing/demandDetail?id=${item.id}&show=true`);
      } else if (active === 'orgList') {
        // 打开新标签页
        item.id && window.open(`/shop?id=${item.id}`);
      }
    },

    fold(arrowDownRefs, thinkMessageRefs) {
      this.$nextTick(() => {
        const display = this.$refs[thinkMessageRefs][0].style.display;
        const arrowDown = this.$refs[arrowDownRefs][0].$el;
        this.$refs[thinkMessageRefs][0].style.display = display === 'none' ? 'block' : 'none';
        arrowDown.style.transform = display === 'none' ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    },
    scrollToBottom() {
      this.$refs.ChatBox.scrollTop = this.$refs.ChatBox.scrollHeight;
    },
    getContenteditableValue() {
      const innerHTML = this.$refs.contenteditable.innerHTML;
      // 获取innerHTL中的input标签
      const inputRegex = /<input[^>]*id="([^"]*)"[^>]*>/g;
      let match;
      let inputs;
      switch (this.type) {
        case 0:
          inputs = {
            goods: '技术领域',
            demand: '应用场景',
            plan: '技术要求',
          };
          break;
        case 1:
          inputs = {
            technology: '技术领域',
            planDesc: '解决方案描述',
          };
          break;
        case 2:
          inputs = {
            demand: '需求描述',
          };
          break;
        case 3:
          inputs = {
            demand: '需求描述',
          };
          break;
        default:
          inputs = {};
          break;
      }
      // 遍历所有匹配的input标签
      while ((match = inputRegex.exec(innerHTML)) !== null) {
        const inputId = match[1];
        const inputElement = document.getElementById(inputId);
        if (inputElement && inputElement.value) {
          inputs[inputId] = inputElement.value;
        }
      }
      // 替换原始字符串中的input标签为输入的值
      let processedContent = innerHTML;
      for (const id in inputs) {
        const value = inputs[id];
        const inputTagRegex = new RegExp(`<input[^>]*id="${id}"[^>]*>`, 'g');
        processedContent = processedContent.replace(inputTagRegex, value);
      }
      // console.log('提取的input值:', inputs);
      // console.log('处理后的内容:', processedContent);
      return processedContent;
    },
    typeWriterBuffer(content, index, key, callback) {
      function* generateText() {
        const tagRegex = /(<\/?[\w\s=\\"'-]+>)/g;
        const segments = content.split(tagRegex);
        let buffer = '';
        for (const segment of segments) {
          if (tagRegex.test(segment)) {
            buffer += segment;
            yield buffer;
            continue;
          }
          for (const char of segment) {
            buffer += char;
            yield buffer;
          }
        }
      }
      const gen = generateText();
      this.timer = setInterval(() => {
        const { value, done } = gen.next();
        if (done) {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          callback();
        } else {
          // displayText = value;
          this.$set(this.questionsAndAnswers[index], key, value);
          // 每次添加字符后滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }, 50);
    },
    typeWriter(content, index, key) {
      return new Promise((resolve) => {
        const fullAnswer = content;
        let displayText = '';
        let i = 0;
        this.interval = setInterval(() => {
          if (i < fullAnswer.length) {
            displayText += fullAnswer.charAt(i);
            this.$set(this.questionsAndAnswers[index], key, displayText);
            i++;
            // 每次添加字符后滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          } else {
            if (this.interval) {
              clearInterval(this.interval);
              this.interval = null;
            }
            resolve('think 完成');
          }
        }, 50); // 调整速度，50毫秒一个字符
      });
    },
    // 发送前校验
    sendBeforValidate() {
      if (!this.user) {
        this.$router.push('/login');
        return false;
      }
      // 判断是否有输入
      else if (this.type === null && !this.question) {
        this.$Message.error('请输入您希望查找的资源:如新材料科技成果、专家、项目');
        return false;
      } else if (this.sendDisabled) {
        return false;
      } else {
        return true;
      }
    },
    // 清空输入框或者初始化输入框
    clearInput() {
      let copyQuestion = '';
      if (!this.showReferenceInfor) {
        copyQuestion = this.question;
        this.question = '';
      } else {
        copyQuestion = this.getContenteditableValue();
        // 如果是模板，提问后，重置输入框
        this.keyword = new Date().getTime();
      }
      return copyQuestion;
    },
    // 重置对话
    resetConversation() {
      // 取消请求
      if (this.cancel) {
        this.cancel('取消聊天请求');
        this.cancel = null;
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.sendDisabled) {
        this.sendDisabled = false;
      }
    },
    // 发送提问
    async generateAnswer(message) {
      // 重置对话
      if (this.sendDisabled) {
        this.resetConversation();
      }
      // 校验
      this.sendDisabled = true;
      // 添加思考信息
      const question = `${this.name},${message}`;
      const answer_question = {
        state: 'thinking',
        question,
        answer: '',
        thinkingTime: '0',
        think: '',
        structuredData: {
          goodsList: [],
          demandList: [],
          orgList: [],
          jlrList: [],
          show: false,
        },
      };
      this.questionsAndAnswers.push(answer_question);

      this.userMessage = message;
      this.botResponse = '';
      this.isStreaming = true;
      this.showBotResponse = true;
      this.totalChars = 0;
      this.errorMessage = '';
      this.messageTime = new Date().toLocaleTimeString();
      this.responseTime = this.messageTime;
      this.partialData = '';

      try {
        await this.fetchStreamResponse(question);
      } catch (error) {
        console.log(error);
        this.sendDisabled = false;
      }
    },
    async fetchStreamResponse(question) {
      const body = {
        query: question,
        inputs: {},
        response_mode: 'streaming',
        user: this.user.id,
      };
      console.log('body', body);

      const encrypted = getEncrypted(body);

      this.controller = new AbortController();
      const lastIndex = this.questionsAndAnswers.length - 1;
      const lastItemQ = this.questionsAndAnswers.at(-1);
      try {
        await fetchEventSource(this.apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.apiKey}`,
          },
          body: JSON.stringify({
            data: encrypted,
          }),
          signal: this.controller.signal,
          openWhenHidden: true,
          onopen: (response) => {
            if (response.status === 200) {
              console.log('SSE连接已建立');
              // this.clearInput();
              // 每次提问都需要清除上次智能匹配推荐结果
              this.$bus.$emit('smartMatchResults', []);
              // 更新时间
              // this.$set(lastItemQ, 'thinkingTime', (duration / 1000).toFixed(2));
              // 更新状态
              // this.$set(lastItemQ, 'state', 'finished');
            } else {
              this.typeWriter('Failed to fetch response. Please try again.', lastIndex, 'think');
              this.typeWriter('出错了', lastIndex, 'title');
              this.sendDisabled = false;
              throw new Error(`HTTP错误: ${response.status}`);
            }
          },
          onmessage: (msg) => {
            // 处理完整消息（如果API直接返回完整JSON消息）
            console.log('收到完整消息:', msg);
            if (msg.data && msg.data !== '[DONE]') {
              try {
                const data = JSON.parse(msg.data);
                // console.log('解析后的数据:', data);
                this.processMessageData(data);
              } catch (error) {
                console.error('解析消息失败:', error);
                // this.errorMessage = '解析响应数据失败';
              }
            }
          },
          onchunk: (chunk) => {
            // 处理原始数据块（用于手动解析可能被截断的消息）
            this.processSSEChunk(chunk);
          },
          onerror: (err) => {
            this.typeWriter('Failed to fetch response. Please try again.', lastIndex, 'think');
            this.typeWriter('出错了', lastIndex, 'title');
            this.sendDisabled = false;
            this.$set(lastItemQ, 'state', 'finished');
            console.error('SSE错误:', err);
            throw err;
          },
          onclose: () => {
            console.log('SSE连接已关闭');
            this.$set(lastItemQ, 'state', 'finished');
            this.isStreaming = false;
          },
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.errorMessage = `流式响应错误: ${error.message}`;
          console.error('流式响应错误:', error);
          this.$set(lastItemQ, 'state', 'finished');
        }
        this.isStreaming = false;
      }
    },

    processSSEChunk(chunk) {
      // 处理可能被截断的消息
      const combinedData = this.partialData + chunk;
      const messages = combinedData.split('\n\n');

      // 检查最后一条消息是否完整
      if (!combinedData.endsWith('\n\n') && messages.length > 0) {
        this.partialData = messages.pop();
      } else {
        this.partialData = '';
      }

      // 处理完整的消息
      messages.forEach((message) => {
        if (!message.trim()) return;

        // 验证SSE格式
        if (message.startsWith('data: ')) {
          const jsonStr = message.substring(6).trim();

          try {
            // 解析JSON数据
            const data = jsonStr === '[DONE]' ? null : JSON.parse(jsonStr);

            if (data) {
              // 处理模型生成的内容
              this.processMessageData(data);
            } else {
              // 流结束标志
              this.isStreaming = false;
              // 当所有的文字都渲染完成后，才可以发送下一条信息
              this.sendDisabled = false;

              this.scrollToBottom();
              console.log('流式响应已完成');
            }
          } catch (error) {
            console.error('解析SSE消息失败:', error, '原始数据:', jsonStr);
            this.errorMessage = '解析响应数据失败';
          }
        } else {
          console.log('忽略非标准SSE消息:', message);
        }
      });
    },
    parseJsonDataOther(dataStr) {
      if (!dataStr) {
        // console.error('data对象不存在');
        return null;
      }
      // 1. 检查是否包含json_data_other:
      if (!dataStr.includes('json_data_other:')) {
        console.log('字符串中不包含 json_data_other:');
        return null;
      }

      try {
        // 2. 提取json_data_other:后面的JSON字符串
        const startIndex = dataStr.indexOf('json_data_other:') + 'json_data_other:'.length;
        const jsonStr = dataStr.substring(startIndex);

        // 3. 解析JSON
        const jsonData = JSON.parse(jsonStr);

        // 4. 提取jsonDataOther
        if (jsonData.data && jsonData.data.jsonDataOther) {
          return jsonData.data.jsonDataOther;
        }

        console.log('未找到jsonDataOther字段');
        return null;
      } catch (error) {
        console.error('解析JSON时出错:', error);
        return null;
      }
    },

    // 提取<summary>到</summary>的内容（原生字符串操作）
    extractSummaryContent(htmlContent) {
      if (!htmlContent) {
        return null;
      }
      // 定义开始和结束标签
      const startTag = '</summary>';
      const endTag = '</details>';

      // 查找标签位置
      const startIndex = htmlContent.indexOf(startTag);
      const endIndex = htmlContent.indexOf(endTag);
      // console.log('htmlContent', htmlContent);
      // console.log('startIndex', startIndex);
      // console.log('endIndex', endIndex);
      // 检查标签是否存在
      if (startIndex === -1 || endIndex === -1 || endIndex <= startIndex) {
        return '';
      }

      // 提取标签之间的内容并去除前后空格
      const content = htmlContent.substring(startIndex + startTag.length, endIndex).trim();

      return content;
    },

    // 去除<details>到</details>的内容（原生字符串操作）
    removeDetailsTags(htmlContent) {
      if (!htmlContent) {
        return null;
      }
      // 正则表达式匹配<details>标签及其内容
      const detailsRegex = /<details[^>]*>[\s\S]*?<\/details>/gi;
      return htmlContent.replace(detailsRegex, '');
    },
    processMessageData(data) {
      console.log('处理消息数据:', data);

      // 获取最后一条问答记录
      const lastIndex = this.questionsAndAnswers.length - 1;
      const lastItemQ = this.questionsAndAnswers.at(-1);

      let answer2 = '';
      let shouldRender = false;

      // 提取内容并累积原始Markdown
      if (data.answer && !data.answer.includes('json_data_other')) {
        answer2 = data.answer;
        this.endTime = new Date().getTime();
        if (!this.thinkingTime) {
          this.thinkingTime = ((this.endTime - this.startTime) / 1000).toFixed(2);
        }

        // 检查是否需要触发解析（关键语法标记或累积长度）
        shouldRender = this.shouldParseMarkdown(answer2);
      }

      if (data.answer && data.answer.includes('json_data_other')) {
        this.jsonDataOther = this.parseJsonDataOther(data.answer);
      }

      console.log('jsonDataOther', this.jsonDataOther);
      console.log('data.event', data.event);
      console.log('data.answer', data.answer);

      // 计算累积的Markdown内容
      const accumulatedMarkdown = (lastItemQ.accumulatedMarkdown || '') + answer2;

      // 更新问答对象
      this.$set(this.questionsAndAnswers, lastIndex, {
        ...lastItemQ,
        question: lastItemQ.question,
        title: data.data ? data.data.title ?? data.data.title : lastItemQ.title,
        answer2: answer2 || lastItemQ.answer2,
        accumulatedMarkdown, // 累积原始Markdown
        answer: shouldRender
          ? marked.parse(accumulatedMarkdown) // 条件触发解析
          : lastItemQ.answer, // 否则保持上次解析结果
        event: data.event,
        thinkingTime: this.thinkingTime,
        jsonDataOther: this.jsonDataOther || lastItemQ.jsonDataOther,
      });

      this.scrollToBottom();

      // 流结束处理
      if (data.event === 'message_end') {
        // 记录当前会话标题
        const ques = this.clearInput();
        if (data.conversation_id !== this.conversationId) {
          const renameParams = {
            user: this.user.id,
            name: this.questionsAndAnswers[lastIndex].question,
            conversation_id: data.conversation_id,
          };
          console.log('renameParams', renameParams);
          const renameEncrypted = getEncrypted(renameParams);
          portal
            .renameConversation({
              body: {
                data: renameEncrypted,
              },
            })
            .catch((err) => {});
        }

        // 流结束后强制完整解析一次
        this.$set(this.questionsAndAnswers, lastIndex, {
          ...this.questionsAndAnswers[lastIndex],
          answer: marked.parse(this.questionsAndAnswers[lastIndex].accumulatedMarkdown || ''),
        });

        // 流结束标志
        this.isStreaming = false;
        console.log('流式响应已完成');

        // 触发智能匹配
        console.log('-------------------jsonDataOther----------------', this.jsonDataOther);
        this.$bus.$emit('smartMatchResults', this.jsonDataOther ?? []);
        this.sendDisabled = false;
        this.scrollToBottom();
      }

      if (data.event === 'error') {
        this.$set(lastItemQ, 'state', 'finished');
        this.typeWriter('Failed to fetch response. Please try again.', lastIndex, 'think');
        this.typeWriter('出错了', lastIndex, 'title');
        this.sendDisabled = false;
      }
    },

    // 判断是否需要解析Markdown（避免频繁解析）
    shouldParseMarkdown(content) {
      // 关键Markdown语法标记
      const markdownMarkers = [
        '\n\n', // 段落分隔符
        '```', // 代码块
        '#', // 标题
        '**', // 粗体
        '* ', // 列表项
        '1. ', // 有序列表
        '![', // 图片
        '[', // 链接
      ];

      // 满足以下条件之一时触发解析
      // return (
      //   content.length > 50 || // 内容长度超过50字符
      //   markdownMarkers.some((marker) => content.includes(marker)) || // 包含Markdown标记
      //   this.questionsAndAnswers.length === 1 // 首次解析
      // );
      return true;
    },

    appendResponse(content) {
      // 更新响应内容
      this.botResponse += content;
      this.totalChars += content.length;
      this.responseTime = new Date().toLocaleTimeString();

      // 滚动到底部
      this.$nextTick(() => {
        const container = this.$refs.responseContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    stopStreaming() {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
        this.isStreaming = false;
      }
    },
  },
};
